var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertWarningFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.27832L3.37854 33.3335H36.6215L20 3.27832ZM18.935 13.3335H21.0648V18.5187L20.5092 24.9077H19.4908L18.935 18.5187V13.3335ZM20 30.0002C19.1667 30.0002 18.5185 29.3523 18.5185 28.5187C18.5185 27.6852 19.1665 27.0373 20 27.0373C20.8102 27.0373 21.4815 27.7085 21.4815 28.5185C21.4815 29.3289 20.8102 30.0002 20 30.0002Z",
    fill: "#FFCF00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningFilled);
export default __webpack_public_path__ + "static/media/alert-warning-filled.955d40c58f7b7eccfd58aade886abacc.svg";
export { ForwardRef as ReactComponent };